import Axios from 'axios';

function createAanvraag(leadAanvraagId, aanbod, recaptchaToken = undefined) {
  const headers = {};
  if (recaptchaToken) headers['x-recaptcha-token'] = recaptchaToken;

  return Axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}/api/v1/aanvraag`,
    {
      leadAanvraagId,
      aanbod
    },
    { headers }
  );
}

export default {
  createAanvraag
};
